import { useState } from "react";
import * as yup from 'yup';

const DEFAULT_ANSWER = {
  text: "",
  isCorrect: false,
};

const useHandleForm = (data, submitCallback, invalidDataCallback) => {

  const isCreate = !Boolean(data);

  const createInitialData = () => {

    const getInitialFieldData = (fieldName) => {
      if (fieldName === "answers") return isCreate ? [DEFAULT_ANSWER] : data[fieldName];
      return isCreate ? "" : data[fieldName];
    }

    const fieldNames = [
      "text",
      "type",
      "answers",
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(createInitialData());

  const answersAreValid = () => {
    if (formData.answers?.some((answer) => !answer.text)) return false;
    if (formData.answers?.every((answer) => !answer.isCorrect)) return false;
    if (formData.type === "U" && formData.answers?.every((answer) => answer.isCorrect)) return false;
    return true;
  }

  const dataIsValid = async () => {
    const schema = yup.object().shape({
      text: yup.object().required(),
      type: yup.string().required(),
      answers: yup.array().nullable()
        .when("type", {
          is: (value) => ["M", "U"].includes(value),
          then: yup.array().of(yup.object().required()).required()
        }),
    });

    return await schema.validate(formData, { abortEarly: false })
      .then((castData) => castData)
      .catch(err => {
        if (err instanceof yup.ValidationError) {
          err.inner.forEach(error => {
            console.log(error.message);
          });
          return false;
        }
      });
  }

  const setAnswerOption = (index, value = DEFAULT_ANSWER) => {
    let auxAnswers = [...formData.answers];

    if (index > auxAnswers.length - 1) {
      auxAnswers.push(value);
    } else {
      auxAnswers[index] = value;
    }

    // si es respuesta unica y correcta, poner las demas como incorrectas
    if (formData.type === "U" && value.isCorrect) {
      auxAnswers = auxAnswers.map((answer, answerIndex) => {
        if (answerIndex === index) return value;
        return ({
          ...answer,
          isCorrect: false,
        })
      });
    }

    setFormData({
      ...formData,
      answers: auxAnswers,
    });
  }

  const deleteAnswerOption = (index) => {
    const auxAnswers = [...formData.answers];
    auxAnswers.splice(index, 1);

    setFormData({
      ...formData,
      answers: auxAnswers,
    });
  }

  const submit = async () => {
    if (await dataIsValid() && answersAreValid()) {
      const dataToSend = {
        ...formData,
      };

      submitCallback(dataToSend);
      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const setFormValue = (value, fieldName) => {
    if (fieldName === "type") {
      setFormData({
        ...formData,
        [fieldName]: value,
        answers: ["M", "U"].includes(value) ? (formData.answers || [DEFAULT_ANSWER]) : null,
      });
      return;
    }

    setFormData({
      ...formData,
      [fieldName]: value,
    });
  }

  return {
    isCreate,
    formData,
    setAnswerOption,
    deleteAnswerOption,
    setFormValue,
    submit,
  };
}

export default useHandleForm;
